module.exports = __webpack_public_path__ + "img/0350ec3.png";